import { type Transaction } from '@kalos/kalos-rpc';

import { type OrderDir } from '../../../tools/helpers';

export type MergeDocuments = {
  document1: string;
  document2: string;
};
export type DuplicateCheck = {
  orderNumber: string;
  invoiceNumber: string;
};
export type State = {
  orderBy: string;
  openMerge: boolean;
  document1: string;
  document2: string;
  orderDir: OrderDir | undefined;
  creatingTransaction: boolean;
  pendingSendNotificationForExistingTransaction: Transaction | undefined;
  error: string | undefined;
  searching: boolean;
  ocrCreateOpen: boolean;
  universalSearch: string | undefined;
  fileData: any | undefined;
  imageWaiverTypePopupOpen: boolean;
  imageWaiverTypeFormData: PopupType;
  transactionToSave: Transaction | undefined;
  mergeDocumentAlert: string;
  elementAction: number;
};

export interface FilterType {
  departmentId: number;
  employeeId: number;
  week: string;
  jobNumber: string;
  isAccepted: boolean | undefined;
  isRejected: boolean | undefined;
  isPending: boolean | undefined;
  amount: number | undefined;
  billingRecorded: boolean;
  universalSearch: string | undefined;
  isProcessed: boolean | undefined;
}

export type PopupType = {
  documentType: 'PickTicket' | 'Receipt' | 'Invoice';
  invoiceWaiverType: number;
};

export enum ACTIONS {
  SET_DELETE_FROM_LOCAL_LIST = 'setDeleteFromLocalList',
  SET_ORDER = 'setOrder',
  SET_PENDING_SEND_NOTIFICATION_FOR_EXISTING_TRANSACTION = 'setPendingSendNotificationForExistingTransaction',
  SET_MERGE_DOCUMENT_ALERT = 'setMergeDocumentAlert',
  SET_MERGE_DOCUMENT1 = 'setMergeDocument1',
  SET_MERGE_DOCUMENT2 = 'setMergeDocument2',
  SET_OPEN_MERGE = 'setOpenMerge',
  SET_OCR_CREATE_OPEN = 'setOcrCreateOpen',

  SET_SEARCHING = 'setSearching',
  SET_CREATING_TRANSACTION = 'setCreatingTransaction',
  SET_ERROR = 'setError',
  SET_UNIVERSAL_SEARCH = 'setUniversalSearch',
  SET_FILE_DATA = 'setFileData',
  SET_VENDORS = 'setVendors',
  SET_IMAGE_WAIVER_TYPE_POPUP_OPEN = 'setImageWaiverTypePopupOpen',
  SET_IMAGE_WAIVER_TYPE_FORM_DATA = 'setImageWaiverTypeFormData',
  SET_TRANSACTION_TO_SAVE = 'setTransactionToSave',
}

export type Action =
  | {
      type: ACTIONS.SET_PENDING_SEND_NOTIFICATION_FOR_EXISTING_TRANSACTION;
      data: Transaction | undefined;
    }
  | { type: ACTIONS.SET_SEARCHING; data: boolean }
  | { type: ACTIONS.SET_CREATING_TRANSACTION; data: boolean }
  | {
      type: ACTIONS.SET_ORDER;
      data: { orderBy: string; orderDir: OrderDir | undefined };
    }
  | { type: ACTIONS.SET_MERGE_DOCUMENT_ALERT; data: string }
  | { type: ACTIONS.SET_ERROR; data: string | undefined }
  | {
      type: ACTIONS.SET_UNIVERSAL_SEARCH;
      data: string | undefined;
    }
  | {
      type: ACTIONS.SET_OCR_CREATE_OPEN;
      data: boolean;
    }
  | {
      type: ACTIONS.SET_OPEN_MERGE;
      data: boolean;
    }
  | {
      type: ACTIONS.SET_MERGE_DOCUMENT1;
      data: string;
    }
  | {
      type: ACTIONS.SET_MERGE_DOCUMENT2;
      data: string;
    }
  | {
      type: ACTIONS.SET_FILE_DATA;
      data: any;
    }
  | {
      type: ACTIONS.SET_IMAGE_WAIVER_TYPE_POPUP_OPEN;
      data: boolean;
    }
  | {
      type: ACTIONS.SET_IMAGE_WAIVER_TYPE_FORM_DATA;
      data: PopupType;
    }
  | {
      type: ACTIONS.SET_TRANSACTION_TO_SAVE;
      data: Transaction | undefined;
    };

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case ACTIONS.SET_MERGE_DOCUMENT_ALERT: {
      return {
        ...state,
        mergeDocumentAlert: action.data,
      };
    }
    case ACTIONS.SET_OCR_CREATE_OPEN: {
      return {
        ...state,
        ocrCreateOpen: action.data,
      };
    }
    case ACTIONS.SET_CREATING_TRANSACTION: {
      return {
        ...state,
        creatingTransaction: action.data,
      };
    }
    case ACTIONS.SET_PENDING_SEND_NOTIFICATION_FOR_EXISTING_TRANSACTION: {
      return {
        ...state,
        pendingSendNotificationForExistingTransaction: action.data,
      };
    }
    case ACTIONS.SET_OPEN_MERGE: {
      return {
        ...state,
        openMerge: action.data,
      };
    }
    case ACTIONS.SET_MERGE_DOCUMENT1: {
      return {
        ...state,
        document1: action.data,
      };
    }
    case ACTIONS.SET_MERGE_DOCUMENT2: {
      return {
        ...state,
        document2: action.data,
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        error: action.data,
      };
    }
    case ACTIONS.SET_UNIVERSAL_SEARCH:
      return {
        ...state,
        universalSearch: action.data,
      };
    case ACTIONS.SET_SEARCHING:
      return {
        ...state,
        searching: action.data,
      };
    case ACTIONS.SET_ORDER:
      return {
        ...state,
        orderBy: action.data.orderBy,
        orderDir: action.data.orderDir,
      };
    case ACTIONS.SET_FILE_DATA:
      return { ...state, fileData: action.data };
    case ACTIONS.SET_IMAGE_WAIVER_TYPE_POPUP_OPEN:
      return { ...state, imageWaiverTypePopupOpen: action.data };
    case ACTIONS.SET_IMAGE_WAIVER_TYPE_FORM_DATA:
      return { ...state, imageWaiverTypeFormData: action.data };
    case ACTIONS.SET_TRANSACTION_TO_SAVE:
      return { ...state, transactionToSave: action.data };

    default:
      return state;
  }
};
